<template>
	<div class="col-sm-12 col-lg-2">
		<div class="filter__wrapper" :class="{open: 'country' === showList, close: 'country' !== showList}">
			<input type="text"
				   :placeholder="$t('filters.country')"
				   class="filter"
				   :class="{open: 'country' === showList, close: 'country' !== showList}"
				   @click="updateShowList('country')"
				   @input="showList = 'country'"
				   v-model="searchByCountry"
			>
			<ul v-show="'country' === showList"
				class="filter__list"
			>

				<li v-for="item in countryList"
					class="filter__list-item"
				>
					<label class="filter__label">{{item.name}}
						<input class="filter__input"
							   type="checkbox"
							   :value="item"
							   :checked="$store.getters.isEventCountryActive(item.code)"
							   @change="changeFilters($event, item)"
						>
						<span class="filter__checkbox"></span>
					</label>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import { mapActions, mapMutations } from 'vuex'

	export default {
		data () {
			return {
				showList: '',
				searchByCountry: ''
			}
		},
		methods: {
			...mapActions(['fetchEvents', 'fetchCountries']),
			...mapMutations(['addEventsCountry']),
			changeFilters (e, item) {
				if (e.target.checked) {
					this.addEventsCountry(item.code)
					this.fetchEvents()
				} else {
					this.$store.commit('removeEventsCountry', item.code)
					this.fetchEvents()
				}
			},
			updateShowList (list) {
				if (this.showList === list) {
					this.showList = ''
				} else {
					setTimeout(() => {
						this.showList = list
					}, 0)
				}
			},
			closeFlitersLists (e) {
				const open = document.querySelector('.open')
				if (open && !e.target.matches('.filter__list, .filter__list *')) {
					this.showList = ''
				}
			}
		},
		computed: {
			countryList () {
				const inputTest = person => {
					const regExp = new RegExp('^' + this.searchByCountry, 'i')
					return regExp.test(person.name)
				}
				return this.$store.state.events.countries.filter(inputTest)
			}
		},
		created () {
			window.addEventListener('click', this.closeFlitersLists)
			this.fetchCountries()
		},
		beforeDestroy () {
			window.removeEventListener('click', this.closeFlitersLists)
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../styles/variables.scss";
	@import "../../../styles/filters.scss";
</style>



// WEBPACK FOOTER //
// src/components/EventsList/Filters/CountryFilterComponent.vue